import React, { useEffect } from "react";

import { StepperEnum, useWizardStepperContext } from "../../contexts/useWizardStepper.context";
import { useGetReportDetailsApi } from "../../api/useGetReportDetailsApi.hook";
import { useSaveReportDetailsApi } from "../../api/useSaveReportDetailsApi";
import { useToast } from "../../../../../shared/context/toast/toast-context";
import WizardReportDataSourcesComponent from "./components/wizard-report-data-sources/wizard-report-data-sources.component";
import WizardReportDetailsComponent from "./components/wizard-report-details/wizard-report-details.component";
import WizardReportFieldsComponent from "./components/wizard-report-fields/wizard-report-fields.component";
import WizardReportFiltersComponent from "./components/wizard-report-filters/wizard-report-filters.component";
import useWizardReportDataContext from "../../contexts/useWizardReportData.context";
import WizardSummaryComponent from "./components/wizard-summary/wizard-summary.component";
import WizardReportPivotingComponent from "./components/wizard-report-pivoting/wizard-report-pivoting.component";
import { useGetOptionsApi } from "../../api/useGetOptionsApi.hook";
import WizardReportStylesComponent from "./components/wizard-report-styles/wizard-report-styles.component";


/**
 * @author Pradeep R <pradeep.rajendran@rldatix.com>
 * @createdOn Dec/01/2024
 */
export default function WizardContentComponent(
    { reportCode, onClose }: {
        reportCode: string | null | undefined;
        onClose: (reloadAll: boolean) => void;
    }
) {

    const { showToast } = useToast();
    const { resetReportData } = useWizardReportDataContext();
    const { activeStep, handleReset } = useWizardStepperContext();

    const { ReportDetailsLoadingIndicator } = useGetReportDetailsApi(reportCode);
    const { saveReportDetailsLoader, ReportDetailsSavingIndicator } = useSaveReportDetailsApi();
    const { FilterOptionsProgressIndicator, GroupByOptionsProgressIndicator, FormatOptionsProgressIndicator } = useGetOptionsApi();


    useEffect(() => {
        if (saveReportDetailsLoader.isSuccess) {
            showToast('Report Saved', 'success');
            handleReset();
            resetReportData();
            onClose(true);
        }

    }, [saveReportDetailsLoader.isSuccess])


    return (<>

        {/* Options-LoadingIndicatorDialogs */}
        <FilterOptionsProgressIndicator />
        <GroupByOptionsProgressIndicator />
        <FormatOptionsProgressIndicator />

        {/* ReportDetails-LoadingProgressDialog */}
        <ReportDetailsLoadingIndicator />

        {/* ReportDetails-SavingProgressDialog */}
        <ReportDetailsSavingIndicator />

        {/* Step: Report Details */}
        {activeStep === StepperEnum.Details && <WizardReportDetailsComponent />}
        {/* Step: Report Data Sources */}
        {activeStep === StepperEnum.DataSources && <WizardReportDataSourcesComponent />}
        {/* Step: Report Fields */}
        {activeStep === StepperEnum.Fields && <WizardReportFieldsComponent />}
        {/* Step: Report Pivoting */}
        {activeStep === StepperEnum.Pivot && <WizardReportPivotingComponent />}
        {/* Step: Report Filters */}
        {activeStep === StepperEnum.Filters && <WizardReportFiltersComponent />}
        {/* Step: Report Styles */}
        {activeStep === StepperEnum.Styles && <WizardReportStylesComponent />}
        {/* Step: Summary */}
        {(activeStep === StepperEnum.Create
            || activeStep === StepperEnum.Update) && <WizardSummaryComponent />}

    </>)
}